<template>
  <b-container class="page-container">
    <Breadcrumbs currentpage="Kies je organisatie" />
    <h1>Selecteer een organisatie om verder te gaan</h1>
    <b-alert show variant="danger"
      ><font-awesome-icon icon="exclamation-circle" /> Uw account is gekoppeld
      aan meerdere organisaties.
    </b-alert>
    <h2>Selecteer een organisatie</h2>
    <b-row class="pt-4">
      <b-col
        v-for="account in accounts"
        :key="account.ContactID"
        class="card-userswitch mt-4 mt-lg-0"
        xs="12"
        sm="12"
        md="12"
        lg="6"
        xl="4"
      >
        <b-card class="mb-4"
          ><p>
            {{ account.CompanyName }}
            <small>{{ account.FullNameWOSalutation }} </small>
          </p>
          <p></p>
          <b-button
            variant="primary"
            :value="account.ContactID"
            :disabled="!account.IsCustomerActive"
            @click="selectContactID"
            >Verder gaan als {{ account.CompanyName }}</b-button
          ></b-card
        >
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Breadcrumbs from '@/components/header/BreadCrumbs'
export default {
  components: { Breadcrumbs },
  data() {
    return {}
  },
  computed: {
    accounts: function() {
      return this.$store.state.accounts.filter(
        account => account.IsCustomerActive === true
      )
    }
  },
  methods: {
    async selectContactID(event) {
      await this.$store.commit('setContactID', {
        contactID: event.target.value
      })
      this.$router.push({ name: 'index', params: { loggedIn: true } })
    }
  }
}
</script>
